'use client';

import { c as _c } from "react/compiler-runtime";
import { Mode } from '@/components/shared/types';
import { modes } from '@/components/shared/config';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from '@/context/I18nContext';
import { getProfileData } from '@/data/loader';
import { ProductManagerPerspective } from '@/components/perspectives';
import { trackEvent } from '@/lib/umami';
import GoUpButton from '@/components/shared/GoUpButton';
const SCROLL_THRESHOLDS = [25, 50, 75, 100];
export default function Home() {
  const $ = _c(19);
  const {
    locale
  } = useTranslation();
  let t0;
  if ($[0] !== locale) {
    t0 = getProfileData(locale);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const profileData = t0;
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set();
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const reachedThresholdsRef = useRef(t1);
  const currentMode = modes[0];
  const design = currentMode.design;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(_temp2, t2);
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      window.scrollTo({
        top: 0,
        behavior: "instant"
      });
      reachedThresholdsRef.current = new Set();
    };
    t4 = [];
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== locale || $[7] !== profileData.contacts.email) {
    t5 = () => {
      navigator.clipboard.writeText(profileData.contacts.email).then(() => {
        setCopied(true);
        trackEvent("email_copy", {
          mode: "pm",
          locale
        });
      }).catch(_temp3);
    };
    $[6] = locale;
    $[7] = profileData.contacts.email;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleCopyEmail = t5;
  let t6;
  let t7;
  if ($[9] !== copied) {
    t6 = () => {
      if (!copied) {
        return;
      }
      const timeoutId = window.setTimeout(() => {
        setCopied(false);
      }, 2000);
      return () => {
        window.clearTimeout(timeoutId);
      };
    };
    t7 = [copied];
    $[9] = copied;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[12] !== locale) {
    t8 = () => {
      const handleScroll = () => {
        const doc = document.documentElement;
        const scrollable = doc.scrollHeight - window.innerHeight;
        if (scrollable <= 0) {
          return;
        }
        const scrollPosition = window.scrollY;
        const scrolledPercent = Math.min(100, Math.round(scrollPosition / scrollable * 100));
        SCROLL_THRESHOLDS.forEach(threshold => {
          if (scrolledPercent >= threshold && !reachedThresholdsRef.current.has(threshold)) {
            reachedThresholdsRef.current.add(threshold);
            trackEvent("scroll_depth", {
              threshold,
              mode: "pm",
              locale
            });
          }
        });
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      handleScroll();
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    t9 = [locale];
    $[12] = locale;
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  useEffect(t8, t9);
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <GoUpButton mode="pm" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== copied || $[17] !== handleCopyEmail) {
    t11 = <>{t10}<ProductManagerPerspective activeMode="pm" design={design} isDark={false} copied={copied} onCopyEmail={handleCopyEmail} /></>;
    $[16] = copied;
    $[17] = handleCopyEmail;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
}
function _temp3() {}
function _temp2() {
  document.body.setAttribute("data-mode", "pm");
  return _temp;
}
function _temp() {
  document.body.removeAttribute("data-mode");
}